import { AttributeList } from "@/modules/dynamic-attributes/entities/attribute-list";
import { useEntityAttributesContext } from "../model/entity-attributes/context";
import { getAttributes } from "../model/entity-attributes/utils";
import { useSelectedGroup } from "../model/selected-group/context";
import { EditAttributeFormInModal } from "./edit-attribute-in-modal";
import { RemoveAttribute } from "./remove-attribute";

export function EditorAttributesList() {
  const { data, loading } = useEntityAttributesContext();
  const { selectedGroup } = useSelectedGroup();

  const dataSource = getAttributes(data, selectedGroup);

  return (
    <AttributeList
      dataSource={dataSource}
      loading={loading}
      RemoveAttribute={RemoveAttribute}
      EditAttribute={EditAttributeFormInModal}
    />
  );
}
